import { render, staticRenderFns } from "./MemoryIssues.vue?vue&type=template&id=702118e4&scoped=true"
import script from "./MemoryIssues.vue?vue&type=script&lang=js"
export * from "./MemoryIssues.vue?vue&type=script&lang=js"
import style0 from "./MemoryIssues.vue?vue&type=style&index=0&id=702118e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702118e4",
  null
  
)

export default component.exports